import React, { useState } from "react";
import {
  FormControl,
  Button,
  ClickAwayListener,
  Fade,
  Radio,
  Grid,
  Paper,
  Popper,
  TextField,
  Typography,
  RadioGroup,
  FormLabel,
  FormControlLabel,
} from "@mui/material";
import Filter from "@mui/icons-material/FilterList";
import { createTheme, ThemeProvider } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    primary: { main: "rgb(38, 118, 198)" },
  },
});

const regionStates = {
  COMESA: [
    "Burundi",
    "Comoros",
    "Democratic Republic of the Congo (DRC)",
    "Djibouti",
    "Egypt",
    "Eritrea",
    "Burundi",
    "Eswatini",
    "Ethiopia",
    "Kenya",
    "Libya",
    "Madagascar",
    "Malawi",
    "Mauritius",
    "Rwanda",
    "Seychelles",
    "Somalia",
    "South Sudan",
    "Sudan",
    "Zambia",
    "Zimbabwe",
    "Tanzania",
  ],
  EAC: ["Burundi", "Kenya", "Rwanda", "South Sudan", "Tanzania", "Uganda","Congo","Somalia"],
  IGAD: [
    "Djibouti",
    "Eritrea",
    "Ethiopia",
    "Kenya",
    "Somalia",
    "South Sudan",
    "Sudan",
    "Uganda",
  ],
  IOC: ["Comoros", "France (Réunion)", "Madagascar", "Mauritius", "Seychelles"],
  SADC: [
    "Angola",
    "Botswana",
    "Comoros",
    "Democratic Republic of the Congo (DRC)",
    "Eswatini",
    "Lesotho",
    "Madagascar",
    "Malawi",
    "Mozambique",
    "Namibia",
    "Seychelles",
    "South Africa",
    "Tanzania",
    "Zambia",
    "Zimbabwe",
    "Tanzania",
  ],
};

export default function ReportFilter({
  status,
  setStatus,
  fundingType,
  setFundingType,
  setStartDate,
  setEndDate,
  organization,
  setOrganization,
  setCountry,
  handleClearFilters,
  handleGenerateReport,
}) {
  const [open, setOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClickAway = () => {
    setOpen(false);
  };

  const id = open ? "simple-popper" : undefined;

  return (
    <ThemeProvider theme={theme}>
      <div>
        <Button
          style={{ margin: "8px 8px" }}
          aria-describedby={id}
          onClick={handleClick}
          variant="outlined"
          color="primary"
        >
          <span style={{ marginLeft: "8px" }}>Filters</span>
          <Filter />
        </Button>
        <Popper
          id={id}
          open={open}
          anchorEl={anchorEl}
          placement="bottom-start"
          transition
        >
          {({ TransitionProps }) => (
            <ClickAwayListener onClickAway={handleClickAway}>
              <Fade {...TransitionProps} timeout={350}>
                <Paper
                  style={{
                    padding: "16px",
                    width: "300px",
                    maxHeight: "400px",
                    overflowY: "auto",
                  }}
                >
                  <Typography variant="h6" gutterBottom>
                    Filter by
                  </Typography>

                  <FormControl style={{ width: "100%" }}>
                    <FormLabel id="demo-radio-buttons-group-label">
                      Organization
                    </FormLabel>
                    <RadioGroup
                      aria-labelledby="demo-radio-buttons-group-label"
                      defaultValue={organization}
                      name="regionalNetwork"
                      onChange={(e) => setOrganization(e.target.value)}
                    >
                      <FormControlLabel
                        value="COMESA"
                        control={<Radio />}
                        label="COMESA"
                      />
                      <FormControlLabel
                        value="IGAD"
                        control={<Radio />}
                        label="IGAD"
                      />
                      <FormControlLabel
                        value="SADC"
                        control={<Radio />}
                        label="SADC"
                      />
                      <FormControlLabel
                        value="EAC"
                        control={<Radio />}
                        label="EAC"
                      />
                      <FormControlLabel
                        value="IOC"
                        control={<Radio />}
                        label="IOC"
                      />
                    </RadioGroup>
                  </FormControl>
                  <FormControl>
                    <FormLabel id="country">Region Country</FormLabel>
                    <RadioGroup
                      aria-labelledby="country"
                      name="country"
                      onChange={(e) => setCountry(e.target.value)}
                    >
                      {regionStates[organization].map((item) => (
                        <FormControlLabel
                          value={item}
                          control={<Radio />}
                          label={item}
                        />
                      ))}
                    </RadioGroup>
                  </FormControl>
                  <FormControl>
                    <FormLabel id="demo-radio-buttons-group-label">
                      Funding Type
                    </FormLabel>
                    <RadioGroup
                      aria-labelledby="demo-radio-buttons-group-label"
                      defaultValue={fundingType}
                      name="fundingType"
                      style={{ marginBottom: "0 10px " }}
                      onChange={(e) => setFundingType(e.target.value)}
                    >
                      <FormControlLabel
                        value="Public Sector"
                        control={<Radio />}
                        label="Public Sector"
                      />
                      <FormControlLabel
                        value="Public -Private Partnership"
                        control={<Radio />}
                        label="Public -Private Partnership"
                      />
                      <FormControlLabel
                        value="Development Partner"
                        control={<Radio />}
                        label="Development Partner"
                      />
                    </RadioGroup>
                  </FormControl>
                  <FormControl>
                    <FormLabel id="demo-radio-buttons-group-label">
                      Status
                    </FormLabel>
                    <RadioGroup
                      aria-labelledby="demo-radio-buttons-group-label"
                      defaultValue={status}
                      name="status"
                      style={{ marginBottom: "0 10px " }}
                      onChange={(e) => setStatus(e.target.value)}
                    >
                      <FormControlLabel
                        value="All"
                        control={<Radio />}
                        label="All"
                      />
                      <FormControlLabel
                        value="Ongoing"
                        control={<Radio />}
                        label="Ongoing"
                      />
                      <FormControlLabel
                        value="Pending"
                        control={<Radio />}
                        label="Pending"
                      />
                      <FormControlLabel
                        value="Complete"
                        control={<Radio />}
                        label="Complete"
                      />
                    </RadioGroup>
                  </FormControl>
                  <Grid container spacing={2}>
                    <Grid item xs={6}>
                      <TextField
                        label="Start Date*"
                        type="date"
                        onChange={(e) => setStartDate(e.target.value)}
                        fullWidth
                        InputLabelProps={{
                          shrink: true,
                        }}
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <TextField
                        label="End Date*"
                        type="date"
                        onChange={(e) => setEndDate(e.target.value)}
                        fullWidth
                        InputLabelProps={{
                          shrink: true,
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <Button
                        style={{ margin: "8px 8px" }}
                        onClick={() => {
                          handleClearFilters();
                          handleClickAway();
                        }}
                        variant="outlined"
                        color="primary"
                      >
                        Clear
                      </Button>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <Button
                        style={{ margin: "8px 8px" }}
                        onClick={() => {
                          handleGenerateReport();
                          handleClickAway();
                        }}
                        variant="contained"
                        color="primary"
                      >
                        Done
                      </Button>
                    </Grid>
                  </Grid>
                </Paper>
              </Fade>
            </ClickAwayListener>
          )}
        </Popper>
      </div>
    </ThemeProvider>
  );
}
